/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.conglomerateMemberships.internal

import kangaroorewards.appsdk.core.network.base.Endpoint

/**
 * The HTTP endpoint for the [ConglomerateMembershipsApi].
 *
 * [Endpoint] has a single [Endpoint.path] parameter ex. "users/me"
 */
internal val ConglomerateMembershipsEndpoint = Endpoint(path = "users/me/businesses?only_memberships=1&include=default_branch,balance,tier_level,catalog_items")
